import { FormattedMessage, useIntl } from 'react-intl';

import Button from '@atlaskit/button/new';
import Checkbox from '@atlaskit/checkbox';
import Form, { CheckboxField, FormFooter, ErrorMessage } from '@atlaskit/form';

import { messages } from './atlassian-intelligence.i18n';
import atlassianIntelligenceUrls from './urls';

type FormData = { acceptToS: boolean };
type FormValidateResult = { acceptToS: string } | undefined;

export type AtlassianIntelligenceTosFormProps = {
  isActivated: boolean;
  onSubmit: (data: FormData) => Promise<FormValidateResult>;
};
export function AtlassianIntelligenceTosForm({
  isActivated,
  onSubmit,
}: AtlassianIntelligenceTosFormProps) {
  const intl = useIntl();

  return (
    <Form<FormData>
      onSubmit={data => {
        if (!data.acceptToS) {
          return {
            acceptToS: intl.formatMessage(
              messages.atlassianIntelligenceValidateAcceptToS
            ),
          };
        }
        return onSubmit(data);
      }}
    >
      {({ formProps, submitting }) => (
        <form {...formProps}>
          <AtlassianIntelligenceTosCheckbox
            testId="tos-checkbox"
            isActivated={isActivated}
          ></AtlassianIntelligenceTosCheckbox>
          <FormFooter>
            <Button
              type="submit"
              isLoading={submitting}
              appearance="primary"
              testId="submit-button"
            >
              {intl.formatMessage(messages.activateButtonText)}
            </Button>
          </FormFooter>
        </form>
      )}
    </Form>
  );
}

export function AtlassianIntelligenceTosCheckbox({
  isActivated,
  testId,
}: {
  isActivated: boolean;
  testId?: string;
}) {
  return (
    <CheckboxField
      name="acceptToS"
      defaultIsChecked={isActivated}
      isDisabled={isActivated}
    >
      {({ fieldProps, error }) => (
        <>
          <Checkbox
            {...fieldProps}
            name="acceptToS"
            testId={testId}
            label={
              <FormattedMessage
                tagName="span"
                {...messages.atlassianIntelligenceActivateTerms}
                values={{
                  link: chunks => (
                    <a href={atlassianIntelligenceUrls.ui.specificToS()}>
                      {chunks}
                    </a>
                  ),
                }}
              />
            }
          />
          {error && <ErrorMessage>{error}</ErrorMessage>}
        </>
      )}
    </CheckboxField>
  );
}
